<template>
    <div class="board_main_box">
        <div class="d-flex align-items-center">
            <span class="iconfont icon-gaojing2 f20 standbyColor"></span>
            <span class="font-12">预警公告：</span>
        </div>
        
         <vue-seamless-scroll :data="listData" class="seamless-warp" :key="scrollKey" :class-option="defaultOption">
            <ul>
                <li class="f14 warning_info_box" v-for="(item,i) in listData" :key="scrollKey+i">
                    <!-- <span class="font-12 dev_name">{{ item.devName }}</span> -->
                    <span class="sinleline alarm_content standbyColor">{{ item.alarmContent }}</span>
                    <span class="font-12 time">{{ item.alarmTime }}</span>
                </li>
            </ul>
        
        </vue-seamless-scroll>
        <span class="cp font-12 baseColor" @click="showWarnList">更多</span>
    </div>
</template>

<script>

    import warnList from './warnList.vue';
    export default {

        props:{
           listData:{
               type: Array,
               default: () => []
                    
           },
           devId: {
             type: String
           }
        },
        data(){
            return {
                defaultOption: {
                
                    singleHeight: 19,
                    // waitTime: 1000,
                    // openWatch: true,
                    // hoverStop: true,
                    direction: 1,
                    limitMoveNum: 2
                
                },
                scrollKey: new Date().getTime(),
           
    
            }
        },
        created(){

        },
        methods:{
            showWarnList(){
                this.showDialog(warnList,{
                    props:{
                        devId:this.devId
                    }
                },{
                    width:'900px',
                    title: '告警列表',
                    dialog:{
                        isBut:false,
                        isCenter:true
                    }
                })
            },
            updateData(){
               this.scrollKey = new Date().getTime()

            }
        }
    }
</script>

<style lang="scss" scoped>
.board_main_box{
        display: flex;
        align-items: center;
        padding: 0 10px;
        box-sizing: border-box;
        height: 100%;
        // border-radius: 5px;
        color: #fff;
        .warning_info_box{
            display: flex;
            align-items: center;
            height: 19px;
            line-height: 19px;

            .alarm_content{
                display: inline-block;
                max-width: 500px;
                font-size: 12px;
            }
            .time{
                flex-shrink: 0;
                color: #888;
                margin: 0 10px 0 10px;
            }
            .dev_name{
                flex-shrink: 0;
                margin-right: 5px;
            }
        }
        .seamless-warp {
            // width: 400px;
            flex: 1;
            min-width: 0px;
          height: 19px;
          overflow: hidden;
        //   position: relative;
        //   overflow-y: auto;
        }
        .mr10{
            margin-right: 10px;
        }
}
.warp {
    height: 19px;
    width: 360px;
    margin: 0 auto;
    overflow: hidden;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      li,
      a {
        display: block;
        height: 19px;
        line-height: 19px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
      }
    }
  }
</style>